import styled, { css } from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "SelectedBlockWrapperstyle__Container",
  componentId: "sc-dg4ytc-0"
})(["", ""], function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected === true && css(["margin:0 -", ";padding:0 ", ";background-color:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(3), getSpacing(3), colorUsage.selectedBlockWrapper.background, colorUsage.selectedBlockWrapper.border, borderRadius.medium);
});
export { Container };